import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { EditAnnouncementForm } from '../EditAnnouncementForm'

export default function EditAnnouncementListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขประกาศหลังบ้าน`}
					description="แก้ไขประกาศหลังบ้าน"
				/>
			</div>
			<Separator />
			<EditAnnouncementForm />
		</div>
	)
}
